export const labels = [
  /* 
    Nijmegen
  */

  // Districts
  { coordinates: [5.827040915990693, 51.85612201554494], label: 'Haven & Industrieterrein' },
  { coordinates: [5.83833555985737, 51.855498622043285], label: 'Nyma' },
  { coordinates: [5.846848915259216, 51.85312379802045], label: 'Honig' },
  { coordinates: [5.841340352446082, 51.84791087358016], label: 'Nijmegen Nieuw-West' },
  { coordinates: [5.8373977139089845, 51.84017472999216], label: 'Nijmegen Oud-West' },
  { coordinates: [5.8645546268211035, 51.84641215812337], label: 'Centrum' },
  { coordinates: [5.846422623636897, 51.82796251794545], label: 'Nijmegen-Midden' },
  { coordinates: [5.873133173973798, 51.863142770844064], label: 'Nijmegen-Noord' },
  { coordinates: [5.876430617834103, 51.83780070978611], label: 'Nijmegen-Oost' },
  { coordinates: [5.9308275856717785, 51.77397935022739], label: 'Groesbeek' },
  { coordinates: [5.934492303838084, 51.768211587639286], label: 'Wijnbouwcentrum' },
  // { coordinates: [5.91170663718205, 51.77129461216248], label: 'Wolfsberg' },

  // Bridges
  // { coordinates: [5.871318216533183, 51.851279674201095], label: 'De Waalbrug' },
  { coordinates: [5.856968754253501, 51.8524000809974], label: 'De Snelbinder' },
  { coordinates: [5.843295506106017, 51.86119628469271], label: 'De Oversteek' },

  // Waters
  { coordinates: [5.882481804622046, 51.85023752095435], label: 'Ooijpolder' },
  { coordinates: [5.84940211427886, 51.85439147677468], label: 'Waal' },
  { coordinates: [5.863216167667844, 51.85022058705056], label: 'Waalkade' },
  { coordinates: [5.857133860579296, 51.85598331749026], label: 'Spiegelwaal' },
  { coordinates: [5.852649447724133, 51.85028426766215], label: 'Handelskade' },
  { coordinates: [5.829144938970245, 51.858434642058455], label: 'Noordkanaalhaven' },

  // Parks
  { coordinates: [5.8576751021857945, 51.84567565414565], label: 'Kronenburgerpark' },
  { coordinates: [5.870051591964597, 51.847637160761195], label: 'Valkhofpark' },
  { coordinates: [5.872643644435328, 51.846960638512456], label: 'Hunnerpark' },
  { coordinates: [5.835395536623082, 51.824330707567015], label: 'Goffertpark' },
  { coordinates: [5.839204551900707, 51.851805608920046], label: 'Westerpark' },
  { coordinates: [5.867738302438255, 51.83956988747531], label: 'Julianapark' },
  { coordinates: [5.877826578991346, 51.83178864918477], label: 'Limospark' },

  // Stations
  { coordinates: [5.852535825213579, 51.84245089657193], label: 'Station Nijmegen ' },
  { coordinates: [5.85974779759627, 51.862590438625546], label: 'Station Lent' },

  // Hotspots
  { coordinates: [5.856003321420133, 51.82727385792748], label: 'De Houtwerf' },
  { coordinates: [5.837279535022162, 51.82238999101497], label: 'N.E.C. Stadion' },

  /*
    Arnhem
  */

  // Locations
  { coordinates: [5.8229248883195055, 52.01182497300516], label: 'Sportcentrum Papendal' },
  { coordinates: [5.867439393988889, 52.034090823016015], label: 'Entree NP Hoge Veluwe' },
  // { coordinates: [5.9153636970409025, 51.97564258225404], label: 'Bij de John Frostbrug' },

  // Parks & such
  { coordinates: [5.914949093229552, 51.97300874945179], label: 'Rijn' },
  { coordinates: [5.931407349096503, 51.970249260195374], label: 'Nieuwe Haven' },
  { coordinates: [5.948195700703934, 51.98664654605409], label: 'Park Presikhaaf' },
  { coordinates: [5.905638690355914, 51.99192646836758], label: 'Park Sonsbeek' },
  { coordinates: [5.9063239082843495, 51.97757491132717], label: 'Rijnkade' },
  // { coordinates: [5.925781480810315, 51.9978934866179], label: 'Klarenbeek' },
  { coordinates: [5.881441809442862, 51.972895545200856], label: 'Meinerswijk' },
  { coordinates: [5.896550852857132, 52.000328035450934], label: 'Zijpendaal' },

  // Districts
  // { coordinates: [5.929212976518301, 51.97837320098955], label: 'Arnhemse Broek' },
  // { coordinates: [5.897175897326122, 51.9886104610282], label: 'Burgermeesterswijk' },
  { coordinates: [5.908984457046188, 51.98088204050052], label: 'Centrum' },
  // { coordinates: [5.921955350077951, 51.98968930809295], label: 'Klarendal' },
  { coordinates: [5.925299762252877, 51.988410832220694], label: 'Modekwartier' },
  // { coordinates: [5.927344943955632, 51.985092501997855], label: 'Molenbeke' },
  // { coordinates: [5.912832019948382, 51.99049374601975], label: 'Sonsbeek-Zuid' },
  { coordinates: [5.919164217144612, 51.98300933697436], label: 'Spijkerkwartier' },
  { coordinates: [5.899969282483312, 51.97677305077974], label: 'Stadsblokken' },

  // Stations
  { coordinates: [5.903414766560388, 51.983889599647455], label: 'Centraal Station' },
  // { coordinates: [5.942365947767087, 51.987683740153955], label: 'Station Presikhaaf' },
  // { coordinates: [5.919863514425799, 51.98520784737201], label: 'Station Velperpoort' },
];
